import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Card, CardContent, Typography, Button, Container } from '@material-ui/core';
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        padding: theme.spacing(4),
    },
    card: {
        minWidth: 300,
        height: '400px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        textAlign: 'center',
        padding: theme.spacing(3),
    },
    title: {
        fontSize: '2rem',
        marginBottom: theme.spacing(2),
    },
    content: {
        fontSize: '1.2rem',
        marginBottom: theme.spacing(3),
    },
    button: {
        marginTop: theme.spacing(3),
        fontSize: '1rem',
        padding: theme.spacing(1.5),
    },
}));

const ProgramRating = () => {
    const classes = useStyles();
    const history = useHistory();

    const goBackHome = () => {
        history.push('/');
    };

    return (
        <Container className={classes.root}>
            <Card className={classes.card}>
                <CardContent>
                    <Typography className={classes.title} variant="h4" component="h2">
                        Program Rating
                    </Typography>
                    <Typography className={classes.content} variant="body1" component="p">
                        Welcome to the Program Rating page. Here you can view and rate various programs based on their performance and content.
                    </Typography>
                    <Button
                        variant="contained"
                        color="primary"
                        className={classes.button}
                        onClick={goBackHome}
                    >
                        Go to Home
                    </Button>
                </CardContent>
            </Card>
        </Container>
    );
};

export default ProgramRating;